var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-reminder.c64472dc.png","uri@2x": __webpack_public_path__ + "icon-reminder.f01de020.png","uri@3x": __webpack_public_path__ + "icon-reminder.aaf8237a.png",
    width: 32,
    height: 32
});